import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = () => ({
  discounts: {
    total: null,
    pages: {},
  },
});

export default {
  state,
  getters,
  actions,
  mutations,
};
